import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ModernTaskList } from './ModernTaskList';
import { RoadmapData } from '../types/roadmap';

interface Task {
  title: string;
  deadline?: string;
  description?: string;
  completed?: boolean;
  indicator?: string; // Показатель выполнения задачи
  subtasks?: Task[];
  resources?: string[] | {
    name: string;
    link: string;
    type?: string;
  }[];
}

interface GoalViewerProps {
  markdown?: string;
  jsonData?: RoadmapData | null;
  completedTasks?: number[];
  onTaskToggle?: (index: number) => void;
  onMarkdownChange?: (newMarkdown: string) => void;
  onSaveToServer?: (roadmapData: RoadmapData) => Promise<void>;
  editable?: boolean;
}

export function GoalViewer({
  markdown,
  jsonData,
  completedTasks = [],
  onTaskToggle = () => {},
  onMarkdownChange,
  onSaveToServer,
  editable = true
}: GoalViewerProps) {
  const [parsedData, setParsedData] = useState<RoadmapData | null>(null);

  useEffect(() => {
    if (jsonData) {
      setParsedData(jsonData);
    } else if (markdown) {
      try {
        const data = JSON.parse(markdown);
        setParsedData(data);
      } catch (e) {
        console.error("Error parsing JSON in GoalViewer:", e);
        setParsedData(null);
      }
    } else {
      setParsedData(null);
    }
  }, [jsonData, markdown]);

  return (
    <div className="space-y-4 sm:space-y-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <ModernTaskList
            jsonData={parsedData}
            completedTasks={completedTasks}
            onTaskToggle={onTaskToggle}
            onMarkdownChange={onMarkdownChange}
            onSaveToServer={onSaveToServer}
            editable={editable}
          />
        </motion.div>
    </div>
  );
}
